import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavigationComponent } from '../navigation/navigation.component';
import { HelpComponent } from '../help/help.component';

/**
 * Legacy (v0) chrome: top header nav + constrained content well.
 * Mounted only under `/v0/**`.
 */
@Component({
  selector: 'app-legacy-shell',
  standalone: true,
  imports: [RouterOutlet, NavigationComponent, HelpComponent],
  template: `
    <app-navigation></app-navigation>
    <div class="main-content">
      <div class="container">
        <router-outlet />
      </div>
    </div>
    <app-help />
  `,
  styleUrl: './legacy-shell.component.scss',
})
export class LegacyShellComponent {}
